import { Employee } from '../../components/Employee/Employee';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { employees } from '../../data/teams';
import styles from './Team.module.scss';

export const Team = () => {
    return (
        <main className={styles.container}>
            {/* Hero Section */}
            <section className={styles.presentation}>
                <div>
                    <h1>Conheça Nosso Time</h1>
                    <nav>
                        <ul>
                            <li>
                                <a href="#diretoria">Diretoria</a>
                            </li>
                            <li>
                                <a href="#comercial">Comercial</a>
                            </li>
                            <li>
                                <a href="#operacoes">Operações</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </section>

            {/* Teams Section */}
            <section className={styles.main}>
                {employees.map((item, index) => (
                    <section
                        key={index}
                        className={styles[item.styles]}
                        id={item.styles}
                        aria-labelledby={`${item.styles}-title`}
                    >
                        <SectionTitle title={item.department} />
                        <div className={styles.employees_container}>
                            {item.data.map((employee, employeeIndex) => (
                                <Employee
                                    key={`${item.styles}-${employeeIndex}`}
                                    name={employee.name}
                                    img_name={employee.image}
                                    role={employee.role}
                                    linkedin={employee.linkedin}
                                />
                            ))}
                        </div>
                    </section>
                ))}
            </section>
        </main>
    );
};
